import React from "react"
import { graphql } from "gatsby"
import { MDXProvider } from "@mdx-js/react"
import { MDXRenderer } from "gatsby-plugin-mdx"
import CssBaseline from "@material-ui/core/CssBaseline"

import { ThemeProvider } from "@material-ui/styles"
import Viewport from "../gatsby-theme-material-ui-top-layout/components/viewport.js"
import theme from "../gatsby-theme-material-ui-top-layout/theme"
import MDXMapper from "./MDXMapper"
import Layout from "./layout"
import { Typography, Grid } from "@material-ui/core"
import Seo from "./seo"
import PageHeadline from "./PageHeadline.js"

export default function PageTemplate({ data: { mdx } }) {
  const lang = mdx.frontmatter?.language || "de"
  const pathSlug = mdx.frontmatter.slug
    .split("/")
    .reduce((pv, cv, index, arr) => {
      if (
        (index === 0 && lang !== "de" && cv !== "") ||
        (index === 1 && lang !== "de" && arr[0] === "")
      ) {
        return [...pv, lang, cv]
      } else {
        pv.push(cv)
        return pv
      }
    }, [])
    .join("/")

  const imageObject = (mdx.frontmatter?.images || []).find(
    img => (img?.childImageSharp || undefined) !== undefined
  )
  const image = imageObject === undefined ? null : imageObject.publicURL
  const imageSize =
    imageObject === undefined ? null : imageObject.childImageSharp.original

  return (
    <>
      <Viewport />
      <ThemeProvider theme={theme}>
        {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
        <CssBaseline />
        <Layout lang={lang}>
          <Seo
            title={mdx.frontmatter.title}
            description={mdx.frontmatter?.excerpt ?? mdx.excerpt}
            slug={pathSlug}
            lang={lang}
            image={image}
            imageSize={imageSize}
          />
          <PageHeadline
            headline={mdx.frontmatter.title}
            image={mdx.frontmatter.images[0]}
          />
          <Grid container justifyContent="space-between">
            <Grid item>
              <Typography>
                {(mdx.frontmatter?.tags ?? []).join(", ")}
              </Typography>
            </Grid>
            <Grid item>
              <Typography>
                {mdx.frontmatter?.date ?? false
                  ? new Date(mdx.frontmatter?.date).toLocaleDateString()
                  : ""}
              </Typography>
            </Grid>
          </Grid>
          <MDXProvider components={MDXMapper}>
            <MDXRenderer pageContext={{ frontmatter: mdx.frontmatter }}>
              {mdx.body}
            </MDXRenderer>
          </MDXProvider>
        </Layout>
      </ThemeProvider>
    </>
  )
}

export const pageQuery = graphql`
  query MyPagesQuery($id: String) {
    mdx(id: { eq: $id }) {
      id
      body
      excerpt
      frontmatter {
        title
        date
        tags
        slug
        excerpt
        images {
          publicURL
          childImageSharp {
            gatsbyImageData(width: 800, quality: 85, layout: CONSTRAINED)
            original {
              height
              width
            }
          }
        }
      }
    }
  }
`
